import axios from 'axios';

export enum KnownError {
  /**
   * Timeout and network unavailable are treated identically as on some operating systems let the request timeout
   * instead of aborting the connection immediately when there is no network.
   */
  NetworkError = 'NetworkError',
}

/**
 * List of constants which are returned as the `errorCode` from API.
 *
 * Keep this in sync with API.
 *
 * @deprecated - should use translation file directly
 */
export enum ErrorCodeConstants {
  /**
   * Returned when portfolio tree calculation APIs cannot calculate weight, track, etc because there are no active
   * portfolios in that portfolio tree.
   */
  NO_ACTIVE_STRATEGIES = 'NO_ACTIVE_STRATEGIES',
  /**
   * Returned when one of the correlation is not calculated or length of track does not match with length of dates.
   */
  BENCHMARK_NOT_ENOUGH_DATA = 'BENCHMARK_NOT_ENOUGH_DATA',
  /**
   * Returned when the specified strategy has no track
   */
  MISSING_TRACK = 'MISSING_TRACK',
  /**
   * Returned when the given upload ticket has expired
   */
  UPLOAD_TICKET_EXPIRED = 'UPLOAD_TICKET_EXPIRED',

  // TODO : Change these depending on api response error message

  /**
   * Returned as default when error 500 has no reason
   */
  ERROR_LOADING_DATA = 'ERROR_LOADING_DATA',
  /**
   * Returned as default when error 500 has no reason for item under analysis master portfolio tree
   */
  ERROR_MASTER_PORTFOLIO = 'ERROR_MASTER_PORTFOLIO',
  CORRELATION_IS_NOT_AVAILABLE_FOR_SINGLE_ITEMS = 'CORRELATION_IS_NOT_AVAILABLE_FOR_SINGLE_ITEMS',
  ERROR_COMPUTE_ACTIVE_RETURN_TRACK = 'ERROR_COMPUTE_ACTIVE_RETURN_TRACK',

  /**
   * Returned when error 504 Gateway Timeout occurs
   */
  LARGE_NUMBER_OF_ACTIVE_TRACKS_FOR_MST = 'LARGE_NUMBER_OF_ACTIVE_TRACKS_FOR_MST',
}

/**
 * Parses the exception thrown and identifies network errors and API errors.
 */
export const parseResponseError = (e: unknown): KnownError | ErrorCodeConstants | null => {
  if (!axios.isAxiosError(e)) {
    return null;
  }

  if (e.code === 'ECONNABORTED' || e.code === 'ERR_NETWORK') {
    return KnownError.NetworkError;
  }

  if (e.response) {
    const data: { errorCode?: unknown } = e.response.data ?? {};

    if (data && typeof data.errorCode === 'string') {
      const errorCode = data.errorCode ?? null;

      if (Object.values(ErrorCodeConstants).includes(errorCode as ErrorCodeConstants)) {
        return data.errorCode as ErrorCodeConstants;
      }
    }
  }

  return null;
};
